module.exports = __webpack_public_path__ + "img/Notisphere_Icon_Crescent_Color_Light.b7e934e3.svg";